<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    class?: string
  }>(),
  {
    class: undefined,
  },
)

const classes = computed(() => ({
  'app-button-group': true,
  [`${props.class}`]: !!props.class,
}))
</script>

<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-button-group {
  display: flex;

  .app-button {
    flex: 1 1 auto;

    &:not(:first-child) {
      margin-left: -1px;
    }

    &:not(:first-child, :last-child) {
      border-radius: 0;
    }

    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
